import BaseService from "./Base.Service";

class ContractService extends BaseService {
  constructor() {
    const model = {
      user_id: { type: Number, required: true },
      start_date: { type: String, required: true },
      remuneration_type: { type: String, required: true },
    };
    super("contracts", model);
  }

  /**
   * Buscar contratos ativos de um usuário
   * @param {number} userId 
   * @returns {Promise}
   */
  async getActiveContractsByUser(userId) {
    const { data } = await this.conn.axios.get(`/contracts?user_id=${userId}&status=ACTIVE`);
    return data;
  }

  /**
   * Encerrar contrato
   * @param {number} id 
   * @param {string} terminationReason 
   * @returns {Promise}
   */
  async terminateContract(id, terminationReason) {
    const { data } = await this.conn.axios.put(`/contracts/${id}/terminate`, {
      termination_reason: terminationReason,
    });
    return data;
  }

  /**
   * Pausar contrato
   * @param {number} id 
   * @param {string} pauseReason 
   * @returns {Promise}
   */
  async pauseContract(id, pauseReason) {
    const { data } = await this.conn.axios.put(`/contracts/${id}/pause`, {
      pause_reason: pauseReason,
    });
    return data;
  }

  /**
   * Reativar contrato pausado
   * @param {number} id 
   * @returns {Promise}
   */
  async reactivateContract(id) {
    const { data } = await this.conn.axios.put(`/contracts/${id}/reactivate`);
    return data;
  }

  /**
   * Exportar todos os contratos (sem paginação) para planilha
   * @param {string} queryString
   * @returns {Promise}
   */
  async exportAll(queryString = '') {
    try {
      const response = await this.conn.axios.get(`/${this.path}/export?${queryString}`);
      return response.data;
    } catch (err) {
      return this.sendError('Erro ao exportar contratos', 400, err);
    }
  }

  /**
   * Buscar contratos com filtros
   * @param {Object} filters
   * @returns {Promise}
   */
  async listWithFilters(filters = {}) {
    const params = new URLSearchParams();
    
    if (filters.status) params.append('status', filters.status);
    if (filters.user_id) params.append('user_id', filters.user_id);
    if (filters.remuneration_type) params.append('remuneration_type', filters.remuneration_type);
    if (filters.page) params.append('page', filters.page);
    
    const { data } = await this.conn.axios.get(`/contracts?${params.toString()}`);
    return data;
  }
}

export default ContractService;
